function SalesTaxInvoiceAccess(salesTaxInvoice: any, can: any) {
  if (salesTaxInvoice) {
    if (salesTaxInvoice.view) can("access", "View_SalesTaxInvoice");
    if (salesTaxInvoice.create) can("create", "Create_SalesTaxInvoice");
    if (salesTaxInvoice.edit) can("create", "Edit_SalesTaxInvoice");
    if (salesTaxInvoice.delete) can("update", "Delete_SalesTaxInvoice");
    if (salesTaxInvoice.approve) can("update", "Approve_SalesTaxInvoice");
  }
}

function PurchaseTaxInvoiceAccess(purchaseTaxInvoice: any, can: any) {
  if (purchaseTaxInvoice) {
    if (purchaseTaxInvoice.view) can("access", "View_PurchaseTaxInvoice");
    if (purchaseTaxInvoice.create) can("create", "Create_PurchaseTaxInvoice");
    if (purchaseTaxInvoice.edit) can("create", "Edit_PurchaseTaxInvoice");
    if (purchaseTaxInvoice.delete) can("update", "Delete_PurchaseTaxInvoice");
    if (purchaseTaxInvoice.approve) can("update", "Approve_PurchaseTaxInvoice");
  }
}

function PP30FormAccess(pp30: any, can: any) {
  if (pp30) {
    if (pp30.view) can("access", "View_PP30");
    if (pp30.create) can("create", "Create_PP30");
    if (pp30.edit) can("create", "Edit_PP30");
    if (pp30.delete) can("update", "Delete_PP30");
    if (pp30.approve) can("update", "Approve_PP30");
  }
}

function VatAccessToPeakData(can: any) {
  can("update", "Vat_Access_To_PeakData");
}

function VatReportOnly(can: any) {
  can("access", "Vat_Report");
}

function VatPaymentOnly(can: any) {
  can("update", "Vat_Payment");
}

function VatTaxFilingOnly(can: any) {
  can("update", "Vat_TaxFiling");
}

function ManageVat(manageVat: any, can: any) {
  const { accessToPeak, payment, pp30, salesTaxInvoice, purchaseTaxInvoice, report, taxFiling } = manageVat;

  SalesTaxInvoiceAccess(salesTaxInvoice, can);
  PurchaseTaxInvoiceAccess(purchaseTaxInvoice, can);
  PP30FormAccess(pp30, can);

  if (accessToPeak && accessToPeak.accessToPeak) VatAccessToPeakData(can);
  if (report && report.print) VatReportOnly(can);
  if (payment && payment.payment) VatPaymentOnly(can);
  if (taxFiling && taxFiling.taxFiling) VatTaxFilingOnly(can);
}
export { ManageVat };
